import * as React from "react";
import "./three-dots.scss";
import {cx} from "emotion";

export const ThreeDots = ({className, actionClassName} = {}) => {
    return <div className={cx("three-dots-4af three-dots", className || "blue-dots", actionClassName || "dot-flashing")} />;
};
